module.exports = __webpack_public_path__ + "img/observa4.a1f8b4a0.jpg";